/**
 * 推广（计划、单元、创意、关键词）
 * 2025年08月01日新增
 */
import { Injectable, inject } from '@angular/core';
import { baseUrl } from '@core/http/http-config';
import { ApiParams, LwHttpRequestService } from '@leafpoda/hiplanet/http';

@Injectable({
  providedIn: 'root',
})
export class PromotionApiService {
  private http = inject(LwHttpRequestService);

  /**
   * 账户组
   **/

  // 创建账户组
  createAdvertiserGroup(params: ApiParams) {
    // 手动埋点 红品智-推广-账户组-创建账户组
    (window as any)?.lwTrackEvent?.add({
      event_id: 294,
      event_code: 'spotlight-promotion-advertiserGroup-createAdvertiserGroup',
      event_type: 'create',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/create.json',
      typeof: 'Array',
      ...params,
    });
  }

  // 获取账户组列表
  getAdvertiserGroupBaseList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/getList.json',
      typeof: 'Object',
      ...params,
    });
  }

  // 更新账户组
  updateAdvertiserGroup(params: ApiParams) {
    // 手动埋点 红品智-推广-账户组-修改账户组名称
    (window as any)?.lwTrackEvent?.add({
      event_id: 295,
      event_code: 'spotlight-promotion-advertiserGroup-updateAdvertiserGroup',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/update.json',
      typeof: 'Array',
      ...params,
    });
  }

  // 批量删除账户组
  deleteAdvertiserGroup(params: ApiParams) {
    // 手动埋点 红品智-推广-账户组-删除账户组
    (window as any)?.lwTrackEvent?.add({
      event_id: 296,
      event_code: 'spotlight-promotion-advertiserGroup-deleteAdvertiserGroup',
      event_type: 'delete',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/batchDelete.json',
      typeof: 'Array',
      ...params,
    });
  }

  // 绑定店铺到账户组
  bindAdvertisers(params: ApiParams) {
    // 手动埋点 红品智-推广-账户-添加至账户组
    (window as any)?.lwTrackEvent?.add({
      event_id: 297,
      event_code: 'spotlight-promotion-advertiserGroup-bindAdvertisers',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/bindAdvertisers.json',
      typeof: 'Array',
      ...params,
    });
  }

  // 从账户组移除店铺
  unbindAdvertisers(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/advertiserGroup/unbindAdvertisers.json',
      typeof: 'Object',
      ...params,
    });
  }

  /**
   * 账户
   */

  // 实时修改账户预算
  updateAccountBudget(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/account/updateAccountBudget',
      typeof: 'Array',
      ...params,
    });
  }

  // 提交账户定时修改预算任务
  addBudgetAccountTask(params: ApiParams) {
    // 手动埋点 红品智-推广-账户-批量修改账户定时预算
    (window as any)?.lwTrackEvent?.add({
      event_id: 284,
      event_code: 'spotlight-promotion-account-addBudgetAccountTask',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/budget/addBudgetAccountTask',
      typeof: 'Array',
      ...params,
    });
  }
  /**
   * 广告组
   */

  // 简略广告组列表
  getCampaignGroupBaseList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaignGroup/getCampaignGroupBaseList',
      ...params,
    });
  }

  // 获取广告组列表
  getCampaignGroupList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaignGroup/getCampaignGroupList',
      ...params,
    });
  }

  // 批量修改广告组状态
  updateCampaignGroup(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaignGroup/updateCampaignGroup',
      typeof: 'Array',
      ...params,
    });
  }

  // 删除广告组
  deleteCampaignGroup(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaignGroup/deleteCampaignGroup',
      typeof: 'Array',
      ...params,
    });
  }

  /**
   * 新建关键词
   */

  // 获取添加关键词计划列表（2025年10月07日注：创编2.0 无此API）
  getAddKeywordCampaignList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/getCampaignList',
      ...params,
    });
  }

  // 获取添加关键词单元列表（2025年10月07日注：创编2.0 无此API）
  getAddKeywordUnitList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/getUnitList',
      ...params,
    });
  }

  // 单个关键词添加
  createKeyword(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/createWords',
      ...params,
    });
  }

  /**
   * 计划相关
   */

  // 批量操作计划（消耗速率、投放日期等）
  batchOperationCampaign(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/batchOperationCampaign',
      typeof: 'Array',
      ...params,
    });
  }

  // 获取计划列表
  getCampaignList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/getCampaignList',
      typeof: 'Object',
      ...params,
    });
  }

  // 定时修改计划预算
  addBudgetCampaignsTask(params: ApiParams) {
    // 手动埋点 红品智-推广-计划-批量修改定时预算
    (window as any)?.lwTrackEvent?.add({
      event_id: 281,
      event_code: 'spotlight-promotion-campaign-addCampaignsTask',
      event_type: 'update',
    });
    return this.http.post({
      url: baseUrl + '/spotlight/budget/addCampaignsTask',
      typeof: 'Array',
      ...params,
    });
  }

  // 获取定时预算配置
  getBudgetTaskList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/budgetTaskList',
      typeof: 'Array',
      ...params,
    });
  }

  // 实时修改计划预算
  updateCampaignsBudget(params: ApiParams) {
    // 手动埋点 红品智-推广-计划-批量修改实时预算
    (window as any)?.lwTrackEvent?.add({
      event_id: 280,
      event_code: 'spotlight-promotion-campaign-updateCampaignsBudget',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/updateCampaignsBudget',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改计划投放时段
  batchUpdateCampaignsTime(params: ApiParams) {
    // 手动埋点 红品智-推广-计划-批量修改投放时段
    (window as any)?.lwTrackEvent?.add({
      event_id: 275,
      event_code: 'spotlight-promotion-campaign-batchUpdateCampaignsTime',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/batchUpdateCampaignsTime',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改计划投放日期
  batchUpdateCampaignsDate(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/batchUpdateCampaignsDate',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改计划名称
  batchUpdateCampaignsName(params: ApiParams) {
    // 手动埋点 红品智-推广-计划-批量修改计划名称
    (window as any)?.lwTrackEvent?.add({
      event_id: 298,
      event_code: 'spotlight-promotion-campaign-batchUpdateCampaignsName',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/batchUpdateCampaignsName',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改计划状态
  batchUpdateCampaignStatus(params: ApiParams) {
    // 手动埋点 红品智-推广-计划-批量开启、暂停、删除
    (window as any)?.lwTrackEvent?.add({
      event_id: 273,
      event_code: 'spotlight-promotion-campaign-batchUpdateCampaignStatus',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/batchUpdateCampaignStatus',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改计划消耗速率
  batchUpdateCampaignsPacingMode(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/campaigns/batchUpdateCampaignsPacingMode',
      typeof: 'Object',
      ...params,
    });
  }

  /**
   * 单元相关
   */

  // 获取单元列表
  getUnitList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/units/getUnitList',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改单元出价
  updateUnitsBid(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-批量修改出价
    (window as any)?.lwTrackEvent?.add({
      event_id: 267,
      event_code: 'spotlight-promotion-unit-batchUpdateUnitBid',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/units/batchUpdateUnitBid',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改单元地域
  batchUpdateUnitCity(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-批量修改地域
    (window as any)?.lwTrackEvent?.add({
      event_id: 269,
      event_code: 'spotlight-promotion-unit-batchUpdateUnitCity',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/units/batchUpdateUnitCity',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改单元年龄
  batchUpdateUnitAge(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-批量修改年龄
    (window as any)?.lwTrackEvent?.add({
      event_id: 270,
      event_code: 'spotlight-promotion-unit-batchUpdateUnitAge',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/units/batchUpdateUnitAge',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改单元性别
  batchUpdateUnitGender(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-批量修改性别
    (window as any)?.lwTrackEvent?.add({
      event_id: 271,
      event_code: 'spotlight-promotion-unit-batchUpdateUnitGender',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/units/batchUpdateUnitGender',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改单元状态
  batchUpdateUnitsStatus(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-批量开启、暂停、删除
    (window as any)?.lwTrackEvent?.add({
      event_id: 266,
      event_code: 'spotlight-promotion-unit-batchUpdateUnitsStatus',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/units/batchUpdateUnitsStatus',
      typeof: 'Object',
      ...params,
    });
  }

  /**
   * 创意相关
   */

  // 批量操作创意
  batchOperationCreative(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/batchOperationCreative',
      typeof: 'Array',
      ...params,
    });
  }

  // 获取创意列表
  getCreativeList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/creativity/getCreativityList',
      typeof: 'Object',
      ...params,
    });
  }

  // 创意自动优化
  batchAutoOptimization(params: ApiParams) {
    // 手动埋点 红品智-推广-创意-批量修改自动优化
    (window as any)?.lwTrackEvent?.add({
      event_id: 263,
      event_code: 'spotlight-promotion-creative-batchAutoOptimization',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/creativity/batchAutoOptimization',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改创意状态
  batchUpdateCreativeStatus(params: ApiParams) {
    // 手动埋点 红品智-推广-创意-批量开启、暂停、删除
    (window as any)?.lwTrackEvent?.add({
      event_id: 264,
      event_code: 'spotlight-promotion-creative-batchUpdateCreativeStatus',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/creativity/batchUpdateCreativeStatus',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改创意标题
  batchUpdateCreativityTitle(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/creativity/batchUpdateCreativityTitle',
      typeof: 'Object',
      ...params,
    });
  }

  /**
   * 定向相关
   */

  // 获取定向列表
  getTargetList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/target/getTargetList',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改定向状态
  batchUpdateTargetStatus(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/target/batchUpdateTargetStatus',
      typeof: 'Array',
      ...params,
    });
  }

  /**
   * 关键词相关
   */

  // 获取关键词列表
  getKeywordList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/getKeywordsList',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改关键词出价
  batchUpdateKeywordBid(params: ApiParams) {
    // 手动埋点 红品智-推广-关键词-批量修改关键词出价
    (window as any)?.lwTrackEvent?.add({
      event_id: 260,
      event_code: 'spotlight-promotion-keyword-batchUpdateKeywordBid',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/keywords/batchUpdateKeywordBid',
      typeof: 'Object',
      ...params,
    });
  }

  // 修改关键词匹配类型
  batchUpdateKeywordPhrase(params: ApiParams) {
    // 手动埋点 红品智-推广-关键词-批量修改匹配类型
    (window as any)?.lwTrackEvent?.add({
      event_id: 261,
      event_code: 'spotlight-promotion-keyword-batchUpdateKeywordPhrase',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/keywords/batchUpdateKeywordPhrase',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改关键词状态
  batchUpdateKeywordStatus(params: ApiParams) {
    // 手动埋点 红品智-推广-关键词-批量开启、暂停、删除
    (window as any)?.lwTrackEvent?.add({
      event_id: 259,
      event_code: 'spotlight-promotion-keyword-batchUpdateKeywordStatus',
      event_type: 'update',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/keywords/batchUpdateKeywordStatus',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量获取关键词是否可以修改出价
  keywordBatchBidCheck(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/keywordBatchBidCheck',
      typeof: 'Object',
      ...params,
    });
  }

  // 批量修改关键词状态任务
  batchUpdateKeywordStatusTask(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/batchUpdateKeywordStatusTask',
      typeof: 'Number',
      ...params,
    });
  }

  /**
   * 否定关键词
   */

  // 获取否定关键词
  getNegativeWords(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/getNegativeWords',
      typeof: 'Object',
      ...params,
    });
  }

  // 添加否定关键词
  createNegativeWords(params: ApiParams) {
    // 手动埋点 红品智-推广-单元-新增否定关键词
    (window as any)?.lwTrackEvent?.add({
      event_id: 268,
      event_code: 'spotlight-promotion-unit-createNegativeWords',
      event_type: 'create',
    });

    return this.http.post({
      url: baseUrl + '/spotlight/keywords/createNegativeWords',
      typeof: 'Array',
      ...params,
    });
  }

  // 删除否定关键词
  delNegativeWords(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/keywords/delNegativeWords',
      typeof: 'Array',
      ...params,
    });
  }

  // 【模板库】查询否定关键词
  getToolsNegativeWordsList(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/getNegativeWordsList',
      typeof: 'Array',
      ...params,
    });
  }

  // 【模板库】保存否定关键词
  createToolsNegativeWords(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/createNegativeWords',
      typeof: 'Array',
      ...params,
    });
  }

  // 【模板库】修改否定关键词名称
  saveToolsNegativeWordsTitle(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/saveNegativeWordsTitle',
      typeof: 'Array',
      ...params,
    });
  }

  // 【模板库】删除否定关键词
  delToolsNegativeWords(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/delNegativeWords',
      typeof: 'Array',
      ...params,
    });
  }

  /**
   * 表格上传工具（表格工具）
   */

  // 表格校验完成后的最终上传到任务列表
  createUpdateTask(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/upload/createUpdateTask',
      typeof: 'Object',
      ...params,
    });
  }

  // 表格上传解析后的校验
  verifyTableData(params: ApiParams) {
    return this.http.post({
      url: baseUrl + '/spotlight/tool/upload/verifyTableData',
      typeof: 'Object',
      ...params,
    });
  }
}
